import React, { useEffect } from "react";
import DisplayField from "./DisplayField";
import { config } from "../../../style";
import ActivityCard from "./ActivityCard";
import DirectionsRailwayIcon from "@mui/icons-material/DirectionsRailway";
import DisplayTextBox from "./DisplayTextBox";

function RailCard({ item = {}, prepareDocumentData }) {
    const dataRef = React.useRef(null);
    useEffect(() => {
        prepareDocumentData(item.id, dataRef.current);
    }, [item]);

    const prepareLeftData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "left", order };
    };
    const prepareRightData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "right", order };
    };
    return (
        <ActivityCard
            label="Rail"
            icon={<DirectionsRailwayIcon fontSize="small" sx={{ color: config.primaryColor }}></DirectionsRailwayIcon>}
            subject={item.subject}
            // date={item.departureStartTimeString}
            timezone={item.departureTimeZoneCode}
            detail={
                <>
                    <DisplayField
                        label="Departure"
                        type="LocationTime"
                        date={item.departureStartTimeString}
                        timezone={item.departureTimeZoneCode}
                        location={item.departureStationOrRail}
                        prepareData={(key, value) => prepareLeftData(key, value, 1)}></DisplayField>
                    <DisplayField
                        label="Arrival"
                        type="LocationTime"
                        date={item.arrivalEndTimeString}
                        timezone={item.arrivalTimeZoneCode}
                        location={item.arrivalStation}
                        prepareData={(key, value) => prepareLeftData(key, value, 2)}></DisplayField>
                    {item.duration && (
                        <DisplayField
                            label="Train Duration"
                            type="Text"
                            text={`${item.duration}`}
                            prepareData={(key, value) => prepareLeftData(key, value, 3)}></DisplayField>
                    )}
                </>
            }
            rightElement={
                <>
                    {item.trainNumber && (
                        <DisplayTextBox
                            title={item.carrier}
                            value={
                                <>
                                    {item.carrierCode} {item.trainNumber}
                                </>
                            }
                            prepareData={(key, value) =>
                                prepareRightData(
                                    key,
                                    value,
                                    1,
                                    `${item.carrierCode ? item.carrierCode : ""} ${
                                        item.trainNumber ? item.trainNumber : ""
                                    }`
                                )
                            }
                        />
                    )}
                    {item.confirmation && (
                        <DisplayTextBox
                            title={"Confirmation #"}
                            value={item.confirmation}
                            prepareData={(key, value) => prepareRightData(key, value, 2)}
                        />
                    )}
                    {item.arrangedBy && (
                        <DisplayTextBox
                            title={"Arranged By"}
                            value={item.arrangedBy}
                            prepareData={(key, value) => prepareRightData(key, value, 2)}
                        />
                    )}
                </>
            }></ActivityCard>
    );
}

export default RailCard;
